<template>
  <div class="f360-radio-group">
    <p class="f360-radio-group__label" v-if="label">{{ label }}</p>

    <el-radio-group v-bind="$attrs" class="f360-radio-group__wrapper">
      <slot />
    </el-radio-group>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  label?: string;
}>();
</script>

<style lang="scss">
@use "@/ui/styles/variables" as *;
@use "@/ui/styles/theme/f360-theme" as *;

.f360-radio-group {
  display: flex;
  flex-direction: column;
  gap: 10px;

  &__label {
    margin: 0;
    font-family: $fontFamily;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
  }

  .financas-radio {
    gap: 8px !important;

    &__inner {
      border-color: #4f4f4f !important;
      background-color: transparent !important;

      &::after {
        background-color: #0055ff !important;
        width: 10px !important;
        height: 10px !important;
      }
    }

    &__label {
      padding: 0;
      font-family: $fontFamily !important;
      font-size: 12px !important;
      font-weight: 400 !important;
      line-height: 16px !important;
      color: #4f4f4f !important;
    }
  }

  .is-disabled {
    .financas-radio__label {
      opacity: 0.5;
    }
  }
}
</style>
